// extracted by mini-css-extract-plugin
module.exports = {"H1":"HomePage_H1__1fVRb","BigMargin":"HomePage_BigMargin__1I3SS"};